import * as amplitude from '@amplitude/analytics-browser';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export class AnalyticsService {

  static trackDocumentUpload(publicId: String) {
    amplitude.track("Document Upload", {
      publicId
    });
  }

  static trackDocumentEdit(publicId: String) {
    amplitude.track("Document Edited", {
      publicId
    });
  }

  static trackDocumentReview(publicId: String) {
    amplitude.track("Document Reviewed", {
      publicId
    });
  }

  static trackDocumentShared(type: 'email' | 'pdf' | 'word') {
    amplitude.track("Document Shared", {
      type
    });
  }

  static trackPurchase() {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-11487205498/Y8agCO_LsOIZEPqww-Uq',
      'value': 29.99,
      'currency': 'GBP',
    });
  }

  static trackSignup() {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-11487205498/JQxtCPv4peAZEPqww-Uq'
    });
  }
}
